import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { SharedDataService } from 'src/app/services/shared-data.service';

@Component({
  selector: 'app-draggable-attachment',
  templateUrl: './draggable-attachment.component.html',
  styleUrls: ['./draggable-attachment.component.scss']
})
export class DraggableAttachmentComponent implements OnInit {
  @Output() filesEmitter: EventEmitter<any[] | any> = new EventEmitter();
  selectedFile: any[] | any = [];
  @Input() supportedFiles: string = '.pdf,.jpg,.png,.jpeg';
  @Input() title: string = 'Only pdf, jpg, jpeg & png formats are allowed';
  @Input() subTitle: string = '';

  // fileSrc: any = [];
  @Input() files: any[] = [];
  @Output() deleteEmitter: EventEmitter<number> = new EventEmitter();
  slideConfig = {
    cssEase: 'linear',
    speed: 700,
    slidesToShow: 3.3,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1
        }
      }
    ]
  };

  constructor(private sharedService: SharedDataService) {}
  slickInit() {
    this.slide();
  }

  ngOnInit() {}
  onSelectAttachment(e: any) {
    let fileData: object = {};
    const event = e?.target?.files;
    if (event.length !== 0) {
      this.selectedFile = [];
      for (let i = 0; i < event.length; i++) {
        this.selectedFile.push(event[i]);
        fileData['file'] = event[i];
        var fReader = new FileReader();
        fReader.onload = (event: ProgressEvent) => {
          this.selectedFile[i].base64File = (<FileReader>event.target).result;
        };
        fReader.readAsDataURL(event[i]);
      }
      setTimeout(() => {
        this.filesEmitter.emit(this.selectedFile);
      }, 500);
    }
  }
  onClick(data: any) {
    data.target.value = '';
  }

  deleteAttachment(index: number) {
    this.deleteEmitter.emit(index);
    setTimeout(() => {
      this.slide();
    }, 500);
  }

  slide() {
    var next = document.getElementsByClassName('slick-next')['0'];
    if (next) {
      next.addEventListener('mouseover', () => {
        document.getElementsByClassName('slick-next')['0'].click();
      });
    }
    var prev = document.getElementsByClassName('slick-prev')['0'];
    if (prev) {
      prev.addEventListener('mouseover', () => {
        document.getElementsByClassName('slick-prev')['0'].click();
      });
    }
  }

  formatBytes(bytes: any) {
    const marker = 1024;
    const kiloBytes = marker;
    const megaBytes = marker * marker;
    const gigaBytes = marker * marker * marker;
    const teraBytes = marker * marker * marker * marker;
    if (bytes < kiloBytes) return bytes + ' Bytes';
    else if (bytes < megaBytes) return (bytes / kiloBytes).toFixed(3) + ' KB';
    else if (bytes < gigaBytes) return (bytes / megaBytes).toFixed(3) + ' MB';
    else return (bytes / gigaBytes).toFixed(3) + ' GB';
  }

  deleteAllAttachment() {
    this.files = [];
  }

 
}
